import {
  Box,
  Breadcrumbs,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useCartListStore, userStore } from "../store/store";
import { useConfirmPopup } from "../components/context/confirmation-context";
import { useSnackBar } from "../components/context/snackbar-context";
import Navbar from "../components/Navbar";
import { UserRequestListService } from "../services/UserRequestListService";
import { NavLink, useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  GetErrorMessageFromResponse,
  ITCatalogOrderXMLCompomnent,
} from "../common/commonFunction";
import { ICartItem } from "../types/categoryListType";
import Loader from "../components/common components/Loader";
import { set, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserDetialsService } from "../services/UserDetialsService";
import InputSelectControlWithSearch from "./../components/controls/InputSelectControlWithSearch";
import AddUpdateAddress from "./Shipping Address/AddUpdateAddress";
import CircularProgress from "@mui/material/CircularProgress";
import { processRequestItems } from "../common/utils";
import { CartCategoryItem } from "../types/cartTypes";
import { EMP_LIFECYCLE_CAT_ID } from "../constants";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useGraphApi } from "../services/useGraphApi";
import { useMsal } from "@azure/msal-react";

// interface ConfirmRequestPage {
//     isSteper: boolean,
//     changeStep: (data: any) => void;
// }
const ConfirmRequestPage: React.FC = () => {
  const [isLoading, setIsloading] = useState<boolean>(false);
  const [isOpenAddUpdateAddressDialog, setIsOpenAddUpdateAddressDialog] =
    React.useState(false);
  const [hasHardware, setHasHardware] = useState<boolean>(false);
  const [isEmployeeLifecycle, setIsEmployeeLifecycle] = useState<boolean>(false);
  const [behalfUserList, setBehalfUserList] = React.useState<any[]>([]);
  const navigate = useNavigate();
  const cStore: any = useCartListStore();
  const uStore: any = userStore();
  const snackbar = useSnackBar();
  const confirmPopupService = useConfirmPopup();
  const [showLoader, setShowLoader] = React.useState(false);
  const { instance, accounts } = useMsal();
  const { getAllUsers } = useGraphApi(instance, accounts);

  const handleRemove = (item: any) => {
    confirmPopupService.showPopup(
      "Are you sure you want to remove this item from cart?",
      () => {
        handleCancelRemoveItemClose(item);
      }
    );
  };
  const handleCancelRequest = () => {
    confirmPopupService.showPopup(
      "Are you sure you want to cancel entire request?",
      () => {
        cancelRequest();
      }
    );
  };
  const validationSchema = Yup.object()
    .shape({
      hasBehalfUser: Yup.boolean(),
      behalfUserId: Yup.string().when(
        "hasBehalfUser",
        ([hasBehalfUser], schema) => {
          return hasBehalfUser
            ? schema.required("Please select behalf of user")
            : schema;
        }
      ),
    })
    .required();

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const showBehalfUser = watch("hasBehalfUser", false);
  const behalfUserId = watch("behalfUserId", "");

  const handleClearCart = () => {
    confirmPopupService.showPopup(
      "This will remove ALL items from your cart. Are you sure you want to continue?",
      handleConfirmClearCart
    );
  };

  const handleConfirmClearCart = () => {
    if (cStore.clearCart(uStore.user.userEmail)) {
      confirmPopupService.hidePopup();
      snackbar.showSnackBar(
        "Your cart has been cleared successfully.",
        "success"
      );
    } else {
      confirmPopupService.hidePopup();
      snackbar.showSnackBar("Your cart has not been cleared.", "error");
    }
    confirmPopupService.hidePopup();
  };

  const cancelRequest = () => {
    if (cStore.clearCart(uStore.user.userEmail)) {
      navigate("/");
      confirmPopupService.hidePopup();
      snackbar.showSnackBar("Your request has been canceled.", "success");
    } else {
      confirmPopupService.hidePopup();
      snackbar.showSnackBar("Your request has not been canceled.", "error");
    }
  };

  const handleConfirmRequest = async () => {
    let items = [];
    setShowLoader(true);
    if (cStore.cartList.length > 0) items = cStore.cartList;

    const createdUserEmail = uStore.getUser().userEmail;
    const createdUserName =
      uStore.getUser().firstName + " " + uStore.getUser().lastName;

    let behalfUserName: string | undefined;
    if (showBehalfUser && behalfUserId) {
      const selectedBehalfUser = Array.isArray(behalfUserList)
        ? behalfUserList.find((option: any) => option.value === behalfUserId)
        : undefined;
      behalfUserName = selectedBehalfUser ? selectedBehalfUser.name : behalfUserId;
    }

    let ItemsWithGeneralHardwareRequest: CartCategoryItem[] | null = null;
    let ItemsWithoutGeneralHardwareRequest: CartCategoryItem[] | null = null;

    let cXMlRequestPayload: string | null = null;

    if (
      items?.some(
        (o: CartCategoryItem) => o.category?.id === EMP_LIFECYCLE_CAT_ID
      )
    ) {
      const {
        processedItems,
        ItemsWithGeneralHardwareRequest: withHardware,
        ItemsWithoutGeneralHardwareRequest: withoutHardware,
      } = processRequestItems(
        items,
        createdUserEmail,
        createdUserName,
        behalfUserName
      );

      ItemsWithGeneralHardwareRequest = withHardware;
      ItemsWithoutGeneralHardwareRequest = withoutHardware;

      cXMlRequestPayload = ITCatalogOrderXMLCompomnent(
        processedItems,
        createdUserName,
        createdUserEmail
      );
    }

    UserRequestListService.SaveConfirmRequestList(
      behalfUserId,
      items,
      createdUserEmail,
      cXMlRequestPayload,
      ItemsWithGeneralHardwareRequest,
      ItemsWithoutGeneralHardwareRequest
    )
      .then((res: any) => {
        if (res) {
          if (res.data.code === 200 && res.data.data === "success") {
            cStore.clearCart(uStore.user.userEmail);
            snackbar.showSnackBar(
              "Your request is successfully sent.",
              "success"
            );
            navigate("/pending-request");
          } else {
            snackbar.showSnackBar(
              "Your request is not sent successfully.",
              "error"
            );
          }
          setShowLoader(false);
        }
      })
      .catch((err) => {
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
        setShowLoader(false);
      });
  };

  const ConvertFormDataToArray = (stringData: any) => {
    const parsedItemObject: any = JSON.parse(stringData);
    return Object.keys(parsedItemObject);
  };
  const handleCancelRemoveItemClose = (item: any): void => {
    let msg: boolean = cStore.RemoveItemFromCart(uStore.user.userEmail, item);

    if (msg) {
      confirmPopupService.hidePopup();
      snackbar.showSnackBar("Item has been removed from your cart.", "success");
    } else {
      confirmPopupService.hidePopup();
      snackbar.showSnackBar(
        "Item has not been removed from your cart.",
        "error"
      );
    }
    CheckCartItemHasHardware();
  };
  
  const getBehalfUserOptions = async () => {
    if (accounts && accounts.length > 0) {
      let res = await getAllUsers();
      setBehalfUserList(
        res.map((user: any) => ({
          label: `${user.firstName} ${user.lastName} - ${user.mail}`,
          value: user.mail,
          name: [user.firstName, user.lastName].filter(Boolean).join(" "),
        }))
      );
    }
  };

  const CheckCartItemHasHardware = () => {
    setHasHardware(false);
    if (cStore.cartList && cStore.cartList.length > 0) {
      cStore.cartList.map((list: any) => {
        if (list.category.categoryName.toLowerCase() === "hardware") {
          setHasHardware(true);
        }
      });
    }

    setIsEmployeeLifecycle(false);
    if (cStore.cartList && cStore.cartList.length > 0) {
      cStore.cartList.map((list: any) => {
        if (list.category.categoryName.toLowerCase() === "employee life cycle") {
          setIsEmployeeLifecycle(true);
        }
      });
    }
  };

  const handleCloseShippingAddressPopup = (isShowPopup: boolean) => {
    setIsOpenAddUpdateAddressDialog(isShowPopup);
  };

  const AddUpdateShippingAddress = (addressDetails: any) => {};

  useEffect(() => {
    CheckCartItemHasHardware();
    setIsloading(false);
  }, [cStore.cartList]);

  useEffect(() => {
    setIsloading(true);
    CheckCartItemHasHardware();
    setIsloading(false);
    setShowLoader(false);
  }, []);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      getBehalfUserOptions();
    }
  }, [accounts]);

  useEffect(() => {
    if (isEmployeeLifecycle && typeof watch("hasBehalfUser") === "undefined") {
      setValue("hasBehalfUser", true);
    }
  }, [isEmployeeLifecycle]);

  //Auto-select behalf user if isEmployeeLifecycle is true and BehalfUserList is loaded
  useEffect(() => {
    if (
      isEmployeeLifecycle &&
      Array.isArray(behalfUserList) &&
      behalfUserList.length > 0 &&
      Array.isArray(cStore.cartList) &&
      cStore.cartList.length > 0
    ) {
      // Find the employee life cycle cart item
      const empLifeCycleItem = cStore.cartList.find(
        (list: any) =>
          list.category &&
          list.category.categoryName &&
          list.category.categoryName.toLowerCase() === "employee life cycle" &&
          list.formData
      );
      if (empLifeCycleItem && empLifeCycleItem.formData) {
        let employeeName = "";
        try {
          const formDataObj =
            typeof empLifeCycleItem.formData === "string"
              ? JSON.parse(empLifeCycleItem.formData)
              : empLifeCycleItem.formData;
          employeeName = formDataObj["CustomColumn63sr"] || "";
        } catch (e) {
          console.error("Error parsing formData:", e);
          employeeName = "";
        }

        if (employeeName) {
          // Split name into first and last
          const nameParts = employeeName.trim().split(/\s+/);
          const firstName = nameParts[0] || "";
          const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
          // Find user in behalfUserList
          const match = behalfUserList.find((user: any) => {
            const [userFirst, userLast] = user.label.split(" - ")[0].split(" ");
            return (
              userFirst &&
              userLast &&
              userFirst.toLowerCase() === firstName.toLowerCase() &&
              userLast.toLowerCase() === lastName.toLowerCase()
            );
          });
          if (match) {
            setValue("behalfUserId", match.value, { shouldValidate: true });
          }
        }
      }
    }
  }, [isEmployeeLifecycle, behalfUserList, cStore.cartList, setValue]);

  return (
    <>
      <div className="breadcumDiv">
        <Breadcrumbs
          separator={<ArrowForwardIosIcon />}
          aria-label="breadcrumb"
        >
          <NavLink to="/search" title="Make a Request">
            Make a Request
          </NavLink>
          <span className="active-breadcumb"> Confirm Request</span>
        </Breadcrumbs>
      </div>
      <Navbar title="Confirm Request " />

      {isLoading ? (
        <Loader />
      ) : (
        <Paper
          elevation={3}
          sx={{
            m: "auto",
            minWidth: "60%",
            maxWidth: "60%",
            textAlign: "start",
            pr: 0,
          }}
        >
          <form
            onSubmit={handleSubmit(async (data: any, e: any) => {
              handleConfirmRequest();
            })}
          >
            <Typography className="cartHeader" variant="h5" component="div">
              Items in your cart
            </Typography>
            <List
              sx={{ margin: "auto", textAlign: "center", width: "100%", mt: 2 }}
            >
              {cStore.cartList && cStore.cartList.length > 0 ? (
                cStore.cartList.map((list: ICartItem) => {
                  return (
                    <ListItem key={Number(list.id)}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          flexDirection: "row",
                          bgcolor: "background.paper",
                          p: 1,
                          borderRadius: 1,
                        }}
                      >
                        <div className="resulItmeImage">
                          <img alt="" src={list.imageUrl}></img>
                        </div>
                        <div className="resultItemDesc">
                          <div className="resultItemShortDesc">
                            <span>{list.description}</span>
                          </div>
                          <div className="resultItemLongDesc">
                            {list.hasForm && list.formDataWithTitle ? (
                              ConvertFormDataToArray(
                                list.formDataWithTitle
                              ).map((data: any) => {
                                return (
                                  <p>
                                    {data} :{" "}
                                    {JSON.parse(list.formDataWithTitle)[data]}
                                  </p>
                                );
                              })
                            ) : (
                              <p>{list.longDesc}</p>
                            )}
                            {/* {list.longDesc} */}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              marginTop: "10px",
                            }}
                          >
                            <Button
                              variant="contained"
                              onClick={() => {
                                handleRemove(list);
                              }}
                            >
                              Remove from cart
                            </Button>
                          </div>
                        </div>
                      </Box>
                    </ListItem>
                  );
                })
              ) : (
                <label style={{ fontSize: "24px" }}>Your cart is empty</label>
              )}
              {cStore.cartList && cStore.cartList.length > 0 && (
                <>
                  {/* <div>
                                                {
                                                    hasHardware &&
                                                    (<div className='ShippingAddressDiv'>
                                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                            <h2>Your Addresses</h2>
                                                            <Button sx={{ height: "50px" }} variant="contained" onClick={() => {
                                                                setIsOpenAddUpdateAddressDialog(true);
                                                            }}> + Add a new address</Button>
                                                        </Box>
                                                        <hr></hr>

                                                    </div>)
                                                }
                                            </div> */}
                  <div className="BehalfUserDiv">
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={7}>
                        <div className="row">
                          <div className="form-lable col-4">
                            <label></label>
                          </div>
                          <div className="col-8 InputCheckBoxControl">
                            <Autocomplete
                              options={[
                                { label: "Yes", value: false },
                                { label: "No", value: true },
                              ]}
                              getOptionLabel={(option) => option.label}
                              isOptionEqualToValue={(option, value) => option.value === value.value}
                              value={
                                [
                                  { label: "Yes", value: false },
                                  { label: "No", value: true },
                                ].find((opt) => opt.value === (typeof watch("hasBehalfUser") !== "undefined" ? watch("hasBehalfUser") : (isEmployeeLifecycle ? true : false)))
                              }
                              onChange={(_, newValue) => setValue("hasBehalfUser", newValue ? newValue.value : (isEmployeeLifecycle ? true : false))}
                              renderInput={(params) => (
                                <TextField {...params} label="Is request for yourself?" error={!!errors.hasBehalfUser} helperText={errors.hasBehalfUser?.message} />
                              )}
                              disableClearable={true}
                              fullWidth
                              freeSolo={false}
                            />
                          </div>
                        </div>
                      </Grid>
                      {showBehalfUser && (
                        <Grid item xs={12} md={7}>
                          <div className="row">
                            <div
                              className="form-lable col-4"
                              style={{ textAlign: "left", marginBottom: "5px" }}
                            >
                              <label>Specify User on Behalf:</label>
                            </div>
                            <div className="col-8">
                              <InputSelectControlWithSearch
                                errors={errors}
                                control={control}
                                name="behalfUserId"
                                label=""
                                options={behalfUserList}
                              />
                            </div>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </div>
                </>
              )}
            </List>

            {cStore.cartList && cStore.cartList.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15px",
                }}
              >
                <Button
                  sx={{ marginBottom: 2, marginRight: 1, height: "52px" }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    handleClearCart();
                  }}
                  disabled={cStore.totalCartItem === 0 ? true : false}
                >
                  Clear cart
                </Button>
                <Button
                  type="submit"
                  sx={{
                    marginBottom: 2,
                    marginRight: 1,
                    height: "52px",
                    width: "165px",
                  }}
                  size="large"
                  variant="contained"
                >
                  {showLoader ? (
                    <CircularProgress
                      sx={{ width: "35px", height: "35px" }}
                      color="inherit"
                    />
                  ) : (
                    "Confirm Request"
                  )}
                </Button>
                <Button
                  sx={{ marginBottom: 2, marginRight: 1, height: "52px" }}
                  size="large"
                  variant="contained"
                  onClick={() => {
                    handleCancelRequest();
                  }}
                >
                  Cancel Request
                </Button>
              </div>
            ) : (
              ""
            )}
          </form>
        </Paper>
      )}
      <AddUpdateAddress
        isOpenAddUpdateAddressDialog={isOpenAddUpdateAddressDialog}
        handleCloseShippingAddressPopup={(showPopup) =>
          handleCloseShippingAddressPopup(showPopup)
        }
        AddUpdateShippingAddress={(addressDetails: any) => {
          AddUpdateShippingAddress(addressDetails);
        }}
      />
    </>
  );
};

export default ConfirmRequestPage;
